import { render, staticRenderFns } from "./FallingReward.vue?vue&type=template&id=7d640718&"
import script from "./FallingReward.vue?vue&type=script&lang=js&"
export * from "./FallingReward.vue?vue&type=script&lang=js&"
import style0 from "./FallingReward.vue?vue&type=style&index=0&id=7d640718&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports